module.exports = __webpack_public_path__ + "static/media/vert.78805e99.png";